import { render, staticRenderFns } from "./AccomList.vue?vue&type=template&id=676087f0&scoped=true&"
import script from "./AccomList.vue?vue&type=script&lang=js&"
export * from "./AccomList.vue?vue&type=script&lang=js&"
import style0 from "./AccomList.vue?vue&type=style&index=0&id=676087f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676087f0",
  null
  
)

export default component.exports